// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import {
  getPermLevelIconClassForBoard,
  getPermLevelAltTextForTemplate,
  getPermLevelAltTextForBoard,
} from 'app/scripts/views/internal/BoardDisplayHelpers';
import permsTemplate from 'app/scripts/views/templates/board_header_permissions';
import { l } from 'app/scripts/lib/localize';
import { Auth } from 'app/scripts/db/Auth';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { Analytics } from '@trello/atlassian-analytics';
import { ChangeBoardVisibilityView } from 'app/scripts/views/board-menu/ChangeBoardVisibilityView';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { BoardAddToOrganizationView } from 'app/scripts/views/board-menu/BoardAddToOrganizationView';

export const permChange = function (newPerm) {
  if (newPerm === 'none') {
    Controller.memberHomePage();
  } else {
    // Non-board views and the powerups screen aren't re-rendered when
    // this.render() is called. This is a workaround to avoid a bug where
    // permissions were changing shortly after loading a board and the views
    // were disappearing.
    if (Controller.getCurrentBoardViewSection() !== 'board') {
      this.render();
    }

    // If we can't edit the board, hide the card composer (if it's open)
    if (!this.model.editable()) {
      this.model.composer.save('vis', false);
    }
  }
};

export const renderPermissionLevel = function () {
  // eslint-disable-next-line @trello/enforce-variable-case
  const $perm = $('#permission-level', this.$el);
  const data = {
    permIconClass: getPermLevelIconClassForBoard(this.model),
    permText: l(['board perms', this.model.getPermLevel(), 'name']),
  };

  $perm.html(permsTemplate(data));

  if (this.model.isTemplate()) {
    $perm.attr('title', getPermLevelAltTextForTemplate(this.model));
  } else {
    $perm.attr('title', getPermLevelAltTextForBoard(this.model));
  }

  const canInvite = this.model.canInvite(Auth.me());
  $('.js-manage-board-members', this.$el).toggle(canInvite);

  return this;
};

export const changeVis = function (e) {
  stopPropagationAndPreventDefault(e);
  Analytics.sendClickedButtonEvent({
    buttonName: 'changeBoardVisibilityButton',
    source: 'boardScreen',
  });

  PopOver.toggle({
    elem: $('.js-change-vis', this.$el),
    view: ChangeBoardVisibilityView,
    options: { model: this.model, modelCache: this.modelCache },
  });
};

export const addBoardToTeam = function (e) {
  stopPropagationAndPreventDefault(e);
  Analytics.sendClickedButtonEvent({
    buttonName: 'changeBoardWorkspaceButton',
    source: 'boardScreen',
  });

  return PopOver.toggle({
    elem: $('.js-add-board-to-team', this.$el),
    view: BoardAddToOrganizationView,
    options: { model: this.model, modelCache: this.modelCache },
  });
};
